import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getUsersAsync, selectStateLogin } from '../slice/login.js';

export default function login() {
    const UsuarioS = JSON.parse(window.localStorage.getItem('usuario'));
    if (UsuarioS != null) {//${process.env.URLAPI}
        window.location = `${process.env.BASEURL}/inicio`;
    }
    const [state, setState] = useState({
        email: '',
        password: '',
        isLoading: false
    });
    //const usuario = useSelector(state => state.login.data);
    const usuario = useSelector(selectStateLogin);
    const dispatch = useDispatch();

    //Metodo para asiganar
    const handleInput = (e) => {
        const { value, name } = e.target;
        setState({ ...state, [name]: value });
    };

    const Login = async () => {
        //console.log("state",state);
        $("#backdrop").show();
        setState({ ...state, isLoading: true });
        dispatch(getUsersAsync(state.email, state.password));
    }

    //UseEfect
    useEffect(() => {
        //console.log('Inicio el componente');
        const UsuarioS = JSON.parse(window.localStorage.getItem('usuario'));
        //$("#backdrop").show();
        if(UsuarioS == null){
            window.localStorage.clear();
        }
        
        //console.log('New value', usuario);
        if (usuario.message !== '' && usuario.message != undefined) {
            window.Swal.fire({
                icon: 'error',
                title: 'Error',
                text: usuario.message,
            });
            $("#backdrop").hide();
        }
        if (usuario.message != undefined && usuario.message == '') {
            //console.log("usuario", usuario);
            window.localStorage.setItem('usuario', JSON.stringify(usuario));
            $("#backdrop").hide();
        }
        setState({ ...state, isLoading: false });
    }, [usuario])

    return (
        <>
            {UsuarioS != null ? "" :
                <div className="login-area">
                    <div className="container">
                        <div className="login-box ptb--100">
                            <form>
                                <div className="login-form-head">
                                    {/* <h4>Iniciar Sesión</h4> */}
                                   {/*  <img src={require("../assets/logo.png")} /> */}
                                   <img src="/assets/img/logo.png" alt="logo_megabola" />
                                </div>
                                <div className="login-form-body">
                                    <div className="mb-2">
                                        <label className="form-label text-white">Correo</label>
                                        <input type="text" className="form-control" name="email" id="email" value={state.email || ''} onChange={(e) => handleInput(e)}  autoComplete="none"/>
                                    </div>

                                    <div className="mb-2">
                                        <label className="form-label text-white">Contraseña</label>
                                        <input type="password" className="form-control" name="password" id="password" value={state.password || ''} onChange={(e) => handleInput(e)} autoComplete="none" />
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col d-flex justify-content-center">
                                            {/* <a href="#!">¿Olvidó su contraseña?</a> */}
                                        </div>
                                    </div>
                                    <div className="d-grid gap-2">
                                        <button 
                                            className="btn btn-primary" 
                                            style={{
                                                background: "#E1C34C",
                                                borderColor: "#E1C34C"
                                            }}
                                            type="button" 
                                            onClick={() => Login()} 
                                            disabled={state.email === '' && state.password === ''}>
                                                Iniciar sesión
                                            </button>
                                        {/*  <button className="btn btn-primary" type="button" onClick={() => console.log("sesion",window.localStorage.getItem('usuario'))}>Sesion</button> */}
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col d-flex justify-content-center">
                                            {/* {state.isLoading ? "Cargando..." : "Sin carga"} */}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>}

        </>
    )
}
